var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Spark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-confetti",
    clipPath: "url(#clip0_23663_37268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.4999 22C42.0522 22 42.4999 21.5523 42.4999 21C42.4999 20.4477 42.0522 20 41.4999 20C40.9476 20 40.4999 20.4477 40.4999 21C40.4999 21.5523 40.9476 22 41.4999 22Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.5 18.0001C38.0523 18.0001 38.5 17.5524 38.5 17.0001C38.5 16.4478 38.0523 16.0001 37.5 16.0001C36.9477 16.0001 36.5 16.4478 36.5 17.0001C36.5 17.5524 36.9477 18.0001 37.5 18.0001Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.4999 13.9999C42.0522 13.9999 42.4999 13.5522 42.4999 12.9999C42.4999 12.4476 42.0522 11.9999 41.4999 11.9999C40.9476 11.9999 40.4999 12.4476 40.4999 12.9999C40.4999 13.5522 40.9476 13.9999 41.4999 13.9999Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.5 10C38.0523 10 38.5 9.55228 38.5 9C38.5 8.44772 38.0523 8 37.5 8C36.9477 8 36.5 8.44772 36.5 9C36.5 9.55228 36.9477 10 37.5 10Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.4999 22C60.0521 22 60.4999 21.5523 60.4999 21C60.4999 20.4477 60.0521 20 59.4999 20C58.9476 20 58.4999 20.4477 58.4999 21C58.4999 21.5523 58.9476 22 59.4999 22Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M55.5 18.0001C56.0523 18.0001 56.5 17.5524 56.5 17.0001C56.5 16.4478 56.0523 16.0001 55.5 16.0001C54.9477 16.0001 54.5 16.4478 54.5 17.0001C54.5 17.5524 54.9477 18.0001 55.5 18.0001Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.4999 13.9999C60.0521 13.9999 60.4999 13.5522 60.4999 12.9999C60.4999 12.4476 60.0521 11.9999 59.4999 11.9999C58.9476 11.9999 58.4999 12.4476 58.4999 12.9999C58.4999 13.5522 58.9476 13.9999 59.4999 13.9999Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.5 10C56.0523 10 56.5 9.55228 56.5 9C56.5 8.44772 56.0523 8 55.5 8C54.9477 8 54.5 8.44772 54.5 9C54.5 9.55228 54.9477 10 55.5 10Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.4999 31.9999C51.0522 31.9999 51.4999 31.5521 51.4999 30.9999C51.4999 30.4476 51.0522 29.9999 50.4999 29.9999C49.9476 29.9999 49.4999 30.4476 49.4999 30.9999C49.4999 31.5521 49.9476 31.9999 50.4999 31.9999Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.5 28C47.0523 28 47.5 27.5523 47.5 27C47.5 26.4477 47.0523 26 46.5 26C45.9477 26 45.5 26.4477 45.5 27C45.5 27.5523 45.9477 28 46.5 28Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M50.4999 24.0001C51.0522 24.0001 51.4999 23.5524 51.4999 23.0001C51.4999 22.4478 51.0522 22.0001 50.4999 22.0001C49.9476 22.0001 49.4999 22.4478 49.4999 23.0001C49.4999 23.5524 49.9476 24.0001 50.4999 24.0001Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M46.5 19.9999C47.0523 19.9999 47.5 19.5522 47.5 18.9999C47.5 18.4476 47.0523 17.9999 46.5 17.9999C45.9477 17.9999 45.5 18.4476 45.5 18.9999C45.5 19.5522 45.9477 19.9999 46.5 19.9999Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M51.5001 11C50.9697 11 50.461 10.7893 50.0859 10.4142C49.7108 10.0391 49.5001 9.53043 49.5001 9C49.5001 8.73478 49.3948 8.48043 49.2072 8.29289C49.0197 8.10536 48.7653 8 48.5001 8C48.2349 8 47.9805 8.10536 47.793 8.29289C47.6055 8.48043 47.5001 8.73478 47.5001 9V9C47.5001 9.53043 47.2894 10.0391 46.9143 10.4142C46.5393 10.7893 46.0306 11 45.5001 11C45.2349 11 44.9806 11.1054 44.793 11.2929C44.6055 11.4804 44.5001 11.7348 44.5001 12C44.5001 12.2652 44.6055 12.5196 44.793 12.7071C44.9806 12.8946 45.2349 13 45.5001 13V13C46.0306 13 46.5393 13.2107 46.9143 13.5858C47.2894 13.9609 47.5001 14.4696 47.5001 15C47.5001 15.2652 47.6055 15.5196 47.793 15.7071C47.9805 15.8946 48.2349 16 48.5001 16C48.7653 16 49.0197 15.8946 49.2072 15.7071C49.3948 15.5196 49.5001 15.2652 49.5001 15C49.5001 14.4696 49.7108 13.9609 50.0859 13.5858C50.461 13.2107 50.9697 13 51.5001 13C51.7653 13 52.0197 12.8946 52.2072 12.7071C52.3947 12.5196 52.5001 12.2652 52.5001 12C52.5001 11.7348 52.3947 11.4804 52.2072 11.2929C52.0197 11.1054 51.7653 11 51.5001 11V11Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.5 26.9999C42.9696 26.9999 42.4609 26.7892 42.0858 26.4141C41.7107 26.039 41.5 25.5303 41.5 24.9999C41.5 24.7347 41.3946 24.4803 41.2071 24.2928C41.0196 24.1052 40.7652 23.9999 40.5 23.9999C40.2348 23.9999 39.9804 24.1052 39.7929 24.2928C39.6054 24.4803 39.5 24.7347 39.5 24.9999V24.9999C39.5 25.5303 39.2893 26.039 38.9142 26.4141C38.5391 26.7892 38.0304 26.9999 37.5 26.9999C37.2348 26.9999 36.9804 27.1052 36.7929 27.2928C36.6054 27.4803 36.5 27.7347 36.5 27.9999C36.5 28.2651 36.6054 28.5194 36.7929 28.707C36.9804 28.8945 37.2348 28.9999 37.5 28.9999V28.9999C38.0304 28.9999 38.5391 29.2106 38.9142 29.5857C39.2893 29.9607 39.5 30.4694 39.5 30.9999C39.5 31.2651 39.6054 31.5194 39.7929 31.707C39.9804 31.8945 40.2348 31.9999 40.5 31.9999C40.7652 31.9999 41.0196 31.8945 41.2071 31.707C41.3946 31.5194 41.5 31.2651 41.5 30.9999C41.5 30.4694 41.7107 29.9607 42.0858 29.5857C42.4609 29.2106 42.9696 28.9999 43.5 28.9999V28.9999C43.7652 28.9999 44.0196 28.8945 44.2071 28.707C44.3946 28.5194 44.5 28.2651 44.5 27.9999C44.5 27.7347 44.3946 27.4803 44.2071 27.2928C44.0196 27.1052 43.7652 26.9999 43.5 26.9999Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M59.4999 26.9999C58.9694 26.9999 58.4607 26.7892 58.0857 26.4141C57.7106 26.039 57.4999 25.5303 57.4999 24.9999C57.4999 24.7347 57.3945 24.4803 57.207 24.2928C57.0194 24.1052 56.7651 23.9999 56.4999 23.9999C56.2347 23.9999 55.9803 24.1052 55.7928 24.2928C55.6052 24.4803 55.4999 24.7347 55.4999 24.9999C55.4999 25.5303 55.2892 26.039 54.9141 26.4141C54.539 26.7892 54.0303 26.9999 53.4999 26.9999C53.2347 26.9999 52.9803 27.1052 52.7928 27.2928C52.6052 27.4803 52.4999 27.7347 52.4999 27.9999C52.4999 28.2651 52.6052 28.5194 52.7928 28.707C52.9803 28.8945 53.2347 28.9999 53.4999 28.9999C54.0303 28.9999 54.539 29.2106 54.9141 29.5857C55.2892 29.9607 55.4999 30.4694 55.4999 30.9999C55.4999 31.2651 55.6052 31.5194 55.7928 31.707C55.9803 31.8945 56.2347 31.9999 56.4999 31.9999C56.7651 31.9999 57.0194 31.8945 57.207 31.707C57.3945 31.5194 57.4999 31.2651 57.4999 30.9999C57.4999 30.4694 57.7106 29.9607 58.0857 29.5857C58.4607 29.2106 58.9694 28.9999 59.4999 28.9999V28.9999C59.7651 28.9999 60.0194 28.8945 60.207 28.707C60.3945 28.5194 60.4999 28.2651 60.4999 27.9999C60.4999 27.7347 60.3945 27.4803 60.207 27.2928C60.0194 27.1052 59.7651 26.9999 59.4999 26.9999Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23663_37268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.e09fb8df3fce2bf13a038e9a20a595f9.svg";
export { ForwardRef as ReactComponent };